import gql from "fraql";
import { ref } from "vue";
import { injectAppConfirm, injectSnackbarError } from "@/composables/injections";
import { useTranslation } from "i18next-vue";
import { apolloClient } from "@/plugins/apollo";
export function useSanctionManagementHelper(mutationLoading) {
    const { appConfirm } = injectAppConfirm();
    const { snackbarServerError } = injectSnackbarError();
    const { t } = useTranslation();
    const discardApproveLoading = ref(null);
    async function sanctionApprove(item, refetch) {
        const response = await appConfirm(t("sanctions:ApproveSanctionModal.heading"), t("sanctions:ApproveSanctionModal.question"), {
            confirmText: t("sanctions:ApproveSanctionModal.approveButton.label", "Approve")
        });
        if (!response)
            return;
        mutationLoading.value = true;
        discardApproveLoading.value = "approve-" + item.id;
        try {
            await apolloClient.mutate({
                mutation: gql `
          mutation sanctionApprove($id: ID!) {
            sanctionApprove(input: { id: $id }) {
              sanction {
                id
                approved
                approvedAt
                approvedByPerson {
                  id
                  name
                }
                allowedMutations
              }
            }
          }
        `,
                variables: {
                    id: item.id
                },
                refetchQueries: [refetch()]
            });
        }
        catch (error) {
            snackbarServerError(error, { level: "error" });
        }
        finally {
            mutationLoading.value = false;
            discardApproveLoading.value = null;
        }
    }
    async function sanctionDiscard(item, refetch) {
        const response = await appConfirm(t("sanctions:DiscardSanctionModal.heading"), t("sanctions:DiscardSanctionModal.question"), {
            confirmText: t("sanctions:DiscardSanctionModal.discardButton.label", "Discard"),
            confirmColor: "secondary"
        });
        if (!response)
            return;
        mutationLoading.value = true;
        discardApproveLoading.value = "discard-" + item.id;
        try {
            await apolloClient.mutate({
                mutation: gql `
          mutation sanctionDiscard($id: ID!) {
            sanctionDiscard(input: { id: $id }) {
              sanction {
                id
                allowedMutations
              }
            }
          }
        `,
                variables: {
                    id: item.id
                },
                refetchQueries: [refetch()]
            });
        }
        catch (error) {
            snackbarServerError(error, { level: "error" });
        }
        finally {
            mutationLoading.value = false;
            discardApproveLoading.value = null;
        }
    }
    return {
        discardApproveLoading,
        sanctionApprove,
        sanctionDiscard
    };
}
